import { render, staticRenderFns } from "./FallBackPage.vue?vue&type=template&id=716b78e0&scoped=true"
import script from "./FallBackPage.vue?vue&type=script&lang=js"
export * from "./FallBackPage.vue?vue&type=script&lang=js"
import style0 from "./FallBackPage.vue?vue&type=style&index=0&id=716b78e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716b78e0",
  null
  
)

export default component.exports